<script>
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import {cloneDeep} from "lodash";
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      default: () => [],
    },
    groupSteps: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    MaskedInput
  },
  data(){
    return {
        currencyMask: createNumberMask({
            prefix: "",
            allowDecimal: true,
        }),
        addNew: false,
        form: {
            processTypeId: 0,
            order: '',
            step: "",
            legalBasis: "",
            agencyActionOrder: "",
            agencyAction: "",
            fee: "",
            amount: '',
            processingTimeInMinutes: '',
            processingTime: 0,
            processingTimeRemarks: "",
            responsible: "",
            processType: "minutes",
            category: "",
            categoryModel: ""
        },
        editMode: false,
        addMoreGrp: false,
    }
  },
  methods: {
    getTimeMinutes(time, type){
      if(type === "minutes"){
        return time;
      }else if(type === "hours"){
        return time * 60;
      }else if(type === "days"){
        return time * 60 * 8;
      }else if(type === "weeks"){
        return time * 60 * 8 * 7;
      }else if(type === "months"){
        return time * 60 * 8 * 30;
      }
    },
    getTypeByMinutes(minutes){
      if(minutes < 60){
            return  "minutes";
        }else if(minutes < 480){
            return "hours";
        }else if(minutes < 3360){
            return "days";
        }else if(minutes < 100800){
            return "weeks";
        }else{
            return "months";
        }
    },
    convertToType(minutes){
      if(minutes < 60){
            return  minutes;
        }else if(minutes < 480){
            return minutes / 60;
        }else if(minutes < 3360){
            return minutes / (60 * 8);
        }else if(minutes < 100800){
            return minutes / (60 * 8 * 7);
        }else{
            return minutes / (60 * 8 * 30);
        }
    },
    saveForm(item){
      item.editMode = false;
      let data = cloneDeep(item);
      data.amount = item.amount ? this.getExactAmt(item.amount) : 0;
      data.processingTime = this.getTimeMinutes(item.processingTimeInMinutes, item.processType);
      data.order = this.getExactAmt(item.order);
      this.addNew = false;
      this.editMode = false;
      this.$emit("save", data);
      this.resetForm();
    },
    resetForm(){
        this.form = {
            processTypeId: 0,
            order: '',
            step: "",
            legalBasis: "",
            agencyActionOrder: "",
            agencyAction: "",
            fee: "",
            amount: '',
            processingTimeInMinutes: '',
            processingTime: 0,
            processingTimeRemarks: "",
            responsible: "",
            processType: "minutes",
            category: "",
            categoryModel: ""
        }
    },
    editForm(data){
        data.editMode = true;
        data.editData = {
            id: cloneDeep(data.id),
            processTypeId: cloneDeep(data.processTypeId),
            editMode: false,
            order: cloneDeep(data.order),
            step: cloneDeep(data.step),
            legalBasis: cloneDeep(data.legalBasis),
            agencyActionOrder: cloneDeep(data.agencyActionOrder),
            agencyAction: cloneDeep(data.agencyAction),
            fee: cloneDeep(data.fee),
            amount: cloneDeep(data.amount),
            processingTimeInMinutes: this.convertToType(data.processingTime),
            processingTime: cloneDeep(data.processingTime),
            processingTimeRemarks: cloneDeep(data.processingTimeRemarks),
            responsible: cloneDeep(data.responsible),
            processType: this.getTypeByMinutes(data.processingTimeInMinutes),
            category: cloneDeep(data.category),
            categoryModel: cloneDeep(data.category)
        };
        data.amount = data.amount.toString();
        data.processingTimeInMinutes = this.convertToType(data.processingTime).toString();
        data.processType = this.getTypeByMinutes(data.processingTime);
        data.order = data.order.toString();
        data.agencyActionOrder = data.agencyActionOrder.toString();
        this.editMode = true;
        this.addNew = false;
    },
    removeForm(row){
        this.$emit("remove", row);
    },
    cancelForm(row){
        row.editMode = false;
        this.editMode = false;
        this.$emit("cancel", row.id)
    },  
    createNew(){
        this.addNew = true;
        if(this.steps.length){
            this.form.categoryModel = this.steps[this.steps.length - 1].category;
        }
    },
    formattedText(text){
        return text.replace(/\n/g, "<br>");
    },
    calculateRemarks(){
        this.form.processingTimeRemarks = `${this.form.processingTimeInMinutes} ${this.form.processingTimeInMinutes > 1 ? this.form.processType : this.form.processType.slice(0, -1)}`
    }
  }
};
</script>
<template>
  <div>
    <table class="table table-striped table-hovered table-bordered">
        <thead>
            <tr>
                <th width="10px"></th>
                <th class="text-yellow text-uppercase text-center">Client Steps</th>
                <th class="text-yellow text-uppercase text-center" style="width: 220px;">Legal Basis</th>
                <th class="text-yellow text-uppercase text-center" style="width: 180px;">Agency Actions</th>
                <th class="text-yellow text-uppercase text-center" style="width: 150px;">Fees To be Paid</th>
                <th class="text-yellow text-uppercase text-center" style="width: 250px;">Processing Time</th>
                <th class="text-yellow text-uppercase text-center" >Person Responsible</th>
                <th style="width: 70px;"></th>
            </tr>
        </thead>
        <tbody>
            <template v-if="loading">
                <tr>
                    <td colspan="100%" class="text-center">Loading...</td>
                </tr>
            </template>
            <template v-if="!loading && steps.length">
                <template v-for="(y, yIndex) in groupSteps">
                    <template v-if="y.group.trim() !== '' && y.group.trim() !== 'null'">
                        <tr :key="`${yIndex}`">
                            <td colspan="100%" class="text-left text-info font-weight-bold">{{ y.group }}</td>
                        </tr>
                    </template>
                    <tr v-for="x in y.items" :key="`${yIndex}-${x.id}`">
                        <template v-if="y.group.trim() !== '' && y.group.trim() !== 'null'">
                            <td></td>
                            <td class="text-center">
                                <div v-if="!x.editMode">{{ x.order == 0 ? '' : `${x.order}.` }} {{x.step}}</div>
                                <template v-else>
                                    <input 
                                        type="text" 
                                        v-model="x.categoryModel"
                                        class="form-control mb-1"
                                        placeholder="Enter Category..."
                                        autocomplete="off"
                                    >
                                    <masked-input
                                        autocomplete="off"
                                        type="text"
                                        v-model="x.order"
                                        placeholder="Order"
                                        class="form-control mb-1"
                                        :mask="currencyMask"
                                    >
                                    </masked-input>
                                    <textarea 
                                        class="form-control" 
                                        placeholder="Client Steps"
                                        rows="3"
                                        v-model="x.step"
                                        autofocus
                                    ></textarea>
                                </template>
                            </td>
                        </template>
                        <template v-else>
                            <td class="text-center" colspan="2">
                                <div v-if="!x.editMode">{{ x.order == 0 ? '' : `${x.order}.` }} {{x.step}}</div>
                                <template v-else>
                                    <input 
                                        type="text" 
                                        v-model="x.categoryModel"
                                        class="form-control mb-1"
                                        placeholder="Enter Category..."
                                        autocomplete="off"
                                    >
                                    <masked-input
                                        autocomplete="off"
                                        type="text"
                                        v-model="x.order"
                                        placeholder="Order"
                                        class="form-control mb-1"
                                        :mask="currencyMask"
                                    >
                                    </masked-input>
                                    <textarea 
                                        class="form-control" 
                                        placeholder="Client Steps"
                                        rows="3"
                                        v-model="x.step"
                                        autofocus
                                    ></textarea>
                                </template>
                            </td>
                        </template>
                        <td class="text-center">
                            <div v-if="!x.editMode">
                                <div v-html="formattedText(x.legalBasis)"></div>
                            </div>
                            <template v-else>
                                <textarea 
                                    class="form-control" 
                                    placeholder="Legal Basis"
                                    rows="5"
                                    v-model="x.legalBasis"
                                ></textarea>
                            </template>
                        </td>
                        <td class="text-center">
                            <div v-if="!x.editMode">{{x.agencyActionOrder}}. {{ x.agencyAction }}</div>
                            <template v-else>
                                <input
                                    type="text"
                                    v-model="x.agencyActionOrder"
                                    class="form-control mb-1"
                                    placeholder="Order"
                                    autocomplete="off"
                                />
                                <!-- <masked-input
                                    autocomplete="off"
                                    type="text"
                                    v-model="x.agencyActionOrder"
                                    placeholder="Order"
                                    class="form-control mb-1"
                                    :mask="currencyMask"
                                >
                                </masked-input> -->
                                <textarea 
                                    class="form-control" 
                                    placeholder="Agency Action"
                                    rows="3"
                                    v-model="x.agencyAction"
                                ></textarea>
                            </template>
                        </td>
                        <td class="text-center">
                            <div v-if="!x.editMode" v-html="formattedText(x.fee)"></div>
                            <template v-else>
                                <masked-input
                                    autocomplete="off"
                                    type="text"
                                    v-model="x.amount"
                                    placeholder="Amount"
                                    class="form-control mb-1"
                                    :mask="currencyMask"
                                >
                                </masked-input>
                                <textarea 
                                    class="form-control" 
                                    placeholder="Processing Fee Remarks"
                                    rows="3"
                                    v-model="x.fee"
                                ></textarea>
                            </template>
                        </td>
                        <td class="text-center">
                            <div v-if="!x.editMode">{{x.processingTimeRemarks}}</div>
                            <template v-else>
                                <div class="mb-1 d-flex">
                                    <masked-input
                                        autocomplete="off"
                                        type="text"
                                        v-model="x.processingTimeInMinutes"
                                        placeholder="Time"
                                        class="form-control"
                                        :mask="currencyMask"
                                    >
                                    </masked-input>
                                    <select class="form-select" style="width: 100px;" v-model="x.processType">
                                        <option value="minutes">Minutes</option>
                                        <option value="hours">Hours</option>
                                        <option value="days">Days</option>
                                        <option value="weeks">Weeks</option>
                                        <option value="months">Months</option>
                                    </select>
                                </div>
                                <textarea 
                                    class="form-control" 
                                    placeholder="Processing Time Remarks"
                                    rows="3"
                                    v-model="x.processingTimeRemarks"
                                ></textarea>
                            </template>
                        </td>
                        <td class="text-center">
                            <div v-if="!x.editMode">{{x.responsible}}</div>
                            <template v-else>
                                <textarea 
                                    class="form-control" 
                                    placeholder="Responsible Person"
                                    rows="5"
                                    v-model="x.responsible"
                                ></textarea>
                            </template>
                        </td>
                        <td v-if="!x.editMode">
                            <i class="bx bx-edit me-1 text-primary cursor-pointer font-size-15" @click="editForm(x)"></i>
                            <i class="bx bx-trash text-danger cursor-pointer font-size-15" @click="removeForm(x)"></i>
                        </td>
                        <td v-else class="align-middle">
                            <div class="mb-1">
                                <button type="button" class="btn btn-success btn-sm" @click="saveForm(x)">
                                    <span class="bx bx-check"></span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-danger btn-sm" @click="cancelForm(x)">
                                    <i class="bx bx-x"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </template>
            </template>
            <template v-if="!loading && !steps.length && !addNew">
                <tr>
                    <td colspan="100%" class="text-center">No Data Found</td>
                </tr>
            </template>
            <template v-if="!addNew && !editMode">
                <tr>
                    <td colspan="100%" class="text-center text-info font-weight-bold cursor-pointer" @click="createNew"><i class="bx bx-plus"></i> Add New Step</td>
                </tr>
            </template>
            <template v-if="addNew && !editMode">
                <tr>
                    <td></td>
                    <td>
                        <div class="d-flex mb-1" v-if="!addMoreGrp">
                            <select class="form-select font-weight-bold text-info" v-model="form.categoryModel" >
                                <option value="">No category</option>
                                <option v-for="(step, stepIndex) in groupSteps" :value="step.group" :key="stepIndex">{{ step.group }}</option>
                            </select>
                            <button type="button" @click="addMoreGrp = true" class="btn btn-outline-info btn-sm"><i class="bx bx-plus mx-1"></i></button>
                            </div>
                            <div v-else class="d-flex mb-2">
                            <input 
                                type="text" 
                                v-model="form.categoryModel"
                                class="form-control"
                                placeholder="Enter Category..."
                                autocomplete="off"
                            >
                            <button type="button" @click="addMoreGrp = false" class="btn btn-outline-danger btn-sm"><i class="bx bx-x mx-1"></i></button>
                        </div>
                        <masked-input
                            autocomplete="off"
                            type="text"
                            v-model="form.order"
                            placeholder="Order"
                            class="form-control mb-1"
                            :mask="currencyMask"
                        >
                        </masked-input>
                        <textarea 
                            class="form-control" 
                            placeholder="Client Steps"
                            rows="3"
                            v-model="form.step"
                        ></textarea>
                    </td>
                    <td>
                        <textarea 
                            class="form-control" 
                            placeholder="Legal Basis"
                            rows="5"
                            v-model="form.legalBasis"
                        ></textarea>
                    </td>
                    <td>
                        <input
                            type="text"
                            v-model="form.agencyActionOrder"
                            class="form-control mb-1"
                            placeholder="Order"
                            autocomplete="off"
                        />
                        <!-- <masked-input
                            autocomplete="off"
                            type="text"
                            v-model="form.agencyActionOrder"
                            placeholder="Order"
                            class="form-control mb-1"
                            :mask="currencyMask"
                        >
                        </masked-input> -->
                        <textarea 
                            class="form-control" 
                            placeholder="Agency Action"
                            rows="3"
                            v-model="form.agencyAction"
                        ></textarea>
                    </td>
                    <td>
                        <masked-input
                            autocomplete="off"
                            type="text"
                            v-model="form.amount"
                            placeholder="Amount"
                            class="form-control mb-1"
                            :mask="currencyMask"
                        >
                        </masked-input>
                        <textarea 
                            class="form-control" 
                            placeholder="Processing Fee Remarks"
                            rows="3"
                            v-model="form.fee"
                        ></textarea>
                    </td>
                    <td >
                        <div class="mb-1 d-flex">
                            <masked-input
                                autocomplete="off"
                                type="text"
                                v-model="form.processingTimeInMinutes"
                                placeholder="Time"
                                class="form-control"
                                :mask="currencyMask" 
                                @input="calculateRemarks"
                            >
                            </masked-input>
                            <select class="form-select" style="width: 100px;" v-model="form.processType" @change="calculateRemarks">
                                <option value="minutes">Minutes</option>
                                <option value="hours">Hours</option>
                                <option value="days">Days</option>
                                <option value="weeks">Weeks</option>
                                <option value="months">Months</option>
                            </select>
                        </div>
                        <textarea 
                            class="form-control" 
                            placeholder="Processing Time Remarks"
                            rows="3"
                            v-model="form.processingTimeRemarks"
                        ></textarea>
                    </td>
                    <td colspan="2">
                        <textarea 
                            class="form-control" 
                            placeholder="Responsible Person"
                            rows="5"
                            v-model="form.responsible"
                        ></textarea>
                    </td>
                </tr>
                <tr>
                    <td colspan="100%" class="text-right">
                        <button class="btn btn-success me-2" @click="saveForm(form)">Save</button>
                        <button class="btn btn-secondary" @click="addNew = false">Cancel</button>
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
  </div>
</template>